import goingDialog from "../jsCom/comCtl/goingDialog";
import {AssertUtils,GoingUtils} from "goingutils";
import {_initWinFooterBar} from "../jsCom/utils/bottomBarUtils";

function _initUrlParams(url, params) {
    var paramStr = [];
    if (url.includes("http")) {
        if (AssertUtils.isNotNull(params)) {
            for (let key of Object.keys(params)) {
                paramStr.push(key + "=" + params[key]);
            }
        }
        if (url.indexOf("?") > 0) {
            url = url + "&" + paramStr.join("&");
        } else {
            url = url + "?" + paramStr.join("&");
        }
    }
    return encodeURI(url);
}

let WinUtils = {
    //显示窗口loading
    showLoading(winId){
        goingDialog.showLoading(winId);
    },
    //关闭窗口的loading
    closeLoading(winId){
        goingDialog.closeLoading(winId);
    },
    winIdMap:{},
    getWinHeight: function getWinHeight() {
        return top.document.body.clientHeight;
    },
    alert(msg) {
        goingDialog.alert(msg);
    },
    closeParentCurWin(closeWinFlag = true,winUuid) {
        if(AssertUtils.isNotEmpty(winUuid)){
            let dialogId=this.winIdMap[winUuid];
            if(dialogId!=null&&dialogId>0){
                goingDialog.close(dialogId);
            }
            //设置为null
            this.winIdMap[winUuid]=null;
            //删除相应属性
            delete this.winIdMap[winUuid];
        }else{
            if (this.curWinIds.length > 0) {
                let curWin = this.curWinIds.pop();
                //是否关闭窗口
                if (closeWinFlag) {
                    goingDialog.close(curWin);
                }
            }
        }
    },
    curWin: null,
    curWinIds: [],
    beforeShowWin() {
    },
    executeConfirm(message, fun) {
        goingDialog.confirm(message, fun);
    },
    showInfoOnWin(options) {
        let winUtilsObj = this;
        let dialogWinId="";
        //弹窗前 执行的函数
        winUtilsObj.beforeShowWin(options);
        //默认参数
        let defOptions= {
            width :300,
            overflow : true,
            loadingClose:true,
            height : 400,
            iframe:false,
            url : "",
            domObj:null,
            anim : 2,
            title : false,
            closeType:"return",
            bottomBtn : false
        };
        //参数合并
        options=$.extend(defOptions,options);

        let {url,params,width,height,domObj}=options;
        //如果url存在 才执行
        if (AssertUtils.isNotEmpty(url)) {
            let contentId=url;
            //如果是url 则需要进行相应的参数处理
            url = _initUrlParams(url, params);
            if(domObj!=null&&typeof(domObj)==="object"){
                let newWinId=GoingUtils.getUUid(10);
                $(domObj).attr("id",newWinId);
                contentId=newWinId;
            }

            dialogWinId=goingDialog.open({
                ...options,
                type: 2,
                closeBtn: 1, //不显示关闭按钮
                shade: [0.3],
                area: [`${width}px`, `${height}px`],
                content: [contentId, "no"]
            });
            winUtilsObj.winIdMap[url]=dialogWinId;
            winUtilsObj.curWinIds.push(dialogWinId);

            //初始化窗口底部工具栏
            _initWinFooterBar(
                options,
                dialogWinId,
                url
            );
        }
        return dialogWinId;
    }
};

// @ts-ignore
export default WinUtils;



// WEBPACK FOOTER //
// ./goingsrc/winUtils/index.js